(() => {
  'use strict';

  const PN_TURNSTILE_SITE_KEY =
    '0x4AAAAAAFQSfZdl9oYRuZja';


  function ensureTurnstile(
    form,
    attempt = 0
  ) {

    const container =
      form?.querySelector(
        '[data-pnauth-turnstile]'
      );

    if (!container) return;

    if (
      container.dataset
        .pnTurnstileWidget !==
      undefined
    ) {
      return;
    }

    if (
      window.turnstile &&
      typeof window.turnstile.render ===
        'function'
    ) {

      const widgetId =
        window.turnstile.render(
          container,
          {
            sitekey:
              PN_TURNSTILE_SITE_KEY,
            size:
              'flexible',
            theme:
              'auto'
          }
        );

      container.dataset
        .pnTurnstileWidget =
          String(widgetId);

      return;
    }

    if (attempt < 80) {
      setTimeout(
        () =>
          ensureTurnstile(
            form,
            attempt + 1
          ),
        100
      );
    }

  }


  function captchaTokenFor(
    form
  ) {

    const container =
      form?.querySelector(
        '[data-pnauth-turnstile]'
      );

    const widgetId =
      container?.dataset
        ?.pnTurnstileWidget;

    if (
      widgetId === undefined ||
      !window.turnstile ||
      typeof window.turnstile
        .getResponse !==
        'function'
    ) {
      return '';
    }

    return String(
      window.turnstile.getResponse(
        widgetId
      ) || ''
    ).trim();

  }


  function resetTurnstileFor(
    form
  ) {

    const container =
      form?.querySelector(
        '[data-pnauth-turnstile]'
      );

    const widgetId =
      container?.dataset
        ?.pnTurnstileWidget;

    if (
      widgetId === undefined ||
      !window.turnstile ||
      typeof window.turnstile
        .reset !==
        'function'
    ) {
      return;
    }

    window.turnstile.reset(
      widgetId
    );

  }



  function waitForDB(
    callback,
    attempt = 0
  ) {

    if (window.PeerNestDB) {

      callback();

      return;

    }


    if (attempt < 50) {

      setTimeout(
        () =>
          waitForDB(
            callback,
            attempt + 1
          ),
        100
      );

    }

  }



  function dashboardForRole(
    role
  ) {

    switch (role) {

      case 'admin':
        return '/pages/admin-dashboard';

      case 'mentor':
        return '/pages/mentor-dashboard';

      default:
        return '/pages/student-dashboard';

    }

  }



  function initLoginPage() {

    const page =
      document.querySelector(
        '[data-pnauth-page]'
      );


    if (!page) return;


    const tabs =
      [
        ...page.querySelectorAll(
          '[data-pnauth-tab]'
        )
      ];


    const loginForm =
      page.querySelector(
        '[data-pnauth-login]'
      );


    const signupForm =
      page.querySelector(
        '[data-pnauth-signup]'
      );


    const message =
      page.querySelector(
        '[data-pnauth-message]'
      );



    function showMessage(
      text,
      type = 'error'
    ) {

      message.hidden =
        false;

      message.textContent =
        text;

      message.dataset.type =
        type;

    }




    const authQuery =
      new URLSearchParams(
        window.location.search
      );

    if (
      authQuery.get('reset') ===
      'success'
    ) {

      showMessage(
        'Password updated successfully. You can log in with your new password.',
        'success'
      );

    }



    function clearMessage() {

      message.hidden =
        true;

      message.textContent =
        '';

    }



    function switchTab(
      tab
    ) {

      clearMessage();


      tabs.forEach(button => {

        button.classList.toggle(
          'is-active',
          button.dataset.pnauthTab ===
            tab
        );

      });


      loginForm.hidden =
        tab !== 'login';


      signupForm.hidden =
        tab !== 'signup';


      ensureTurnstile(
        tab === 'signup'
          ? signupForm
          : loginForm
      );

    }



    tabs.forEach(button => {

      button.addEventListener(
        'click',
        () => {

          switchTab(
            button.dataset.pnauthTab
          );

        }
      );

    });


    ensureTurnstile(
      loginForm
    );



    loginForm.addEventListener(
      'submit',
      async event => {

        event.preventDefault();

        clearMessage();


        const submit =
          loginForm.querySelector(
            '[type="submit"]'
          );


        submit.disabled =
          true;


        try {

          const data =
            new FormData(
              loginForm
            );


          const captchaToken =
            captchaTokenFor(
              loginForm
            );

          if (!captchaToken) {
            throw new Error(
              'Please complete the security check.'
            );
          }

          await window.PeerNestDB
            .signIn({
              captchaToken,

              email:
                String(
                  data.get('email') ||
                  ''
                ).trim(),

              password:
                String(
                  data.get('password') ||
                  ''
                )
            });


          const profile =
            await window.PeerNestDB
              .getMyProfile();


          if (!profile) {

            throw new Error(
              'Your PeerNest profile could not be loaded.'
            );

          }


          if (
            profile.account_status !==
            'active'
          ) {

            await window.PeerNestDB
              .signOut();


            throw new Error(
              'This account is currently unavailable.'
            );

          }


          window.location.href =
            '/';

        }

        catch (error) {

          showMessage(
            error.message ||
            'Unable to log in.'
          );

        }

        finally {

          resetTurnstileFor(
            loginForm
          );

          submit.disabled =
            false;

        }

      }
    );



    signupForm.addEventListener(
      'submit',
      async event => {

        event.preventDefault();

        clearMessage();


        const submit =
          signupForm.querySelector(
            '[type="submit"]'
          );


        submit.disabled =
          true;


        try {

          const data =
            new FormData(
              signupForm
            );


          const captchaToken =
            captchaTokenFor(
              signupForm
            );

          if (!captchaToken) {
            throw new Error(
              'Please complete the security check.'
            );
          }

          const result =
            await window.PeerNestDB
              .signUp({

                captchaToken,


                fullName:
                  String(
                    data.get(
                      'full_name'
                    ) ||
                    ''
                  ).trim(),

                email:
                  String(
                    data.get(
                      'email'
                    ) ||
                    ''
                  ).trim(),

                password:
                  String(
                    data.get(
                      'password'
                    ) ||
                    ''
                  )

              });


          /*
            If email confirmation is enabled,
            Supabase can return a user without
            an access token.
          */

          if (
            !result.access_token
          ) {

            switchTab(
              'login'
            );


            showMessage(
              'Account created. We sent a verification link to your email. Check your inbox and spam folder, then open the link to verify your PeerNest account.',
              'success'
            );


            return;

          }


          const profile =
            await window.PeerNestDB
              .getMyProfile();


          window.location.href =
            '/';

        }

        catch (error) {

          showMessage(
            error.message ||
            'Unable to create account.'
          );

        }

        finally {

          resetTurnstileFor(
            signupForm
          );

          submit.disabled =
            false;

        }

      }
    );



    /*
      Already logged in?
      Send user to their dashboard.
    */

    window.PeerNestDB
      .getMyProfile()
      .then(profile => {

        if (
          profile &&
          profile.account_status ===
            'active'
        ) {

          window.location.replace(
            '/'
          );

        }

      })
      .catch(() => {});


    if (
      window.lucide &&
      typeof window.lucide
        .createIcons ===
        'function'
    ) {

      window.lucide.createIcons();

    }

  }




  /* ========================================================
     PN_GLOBAL_AUTH_FOUNDATION
     Global header state + role dashboard guard
  ======================================================== */


  function initialsForProfile(
    profile
  ) {

    const name =
      String(
        profile?.full_name ||
        ''
      ).trim();


    if (name) {

      const pieces =
        name
          .split(/\s+/)
          .filter(Boolean);


      if (pieces.length > 1) {

        return (
          pieces[0][0] +
          pieces[
            pieces.length - 1
          ][0]
        ).toUpperCase();

      }


      return name
        .slice(0,2)
        .toUpperCase();

    }


    const email =
      String(
        profile?.email ||
        ''
      );


    return (
      email[0] ||
      'U'
    ).toUpperCase();

  }



  function profileURLForRole(
    role
  ) {

    return '/pages/profile';

  }



  function setAuthText(
    selector,
    value
  ) {

    document
      .querySelectorAll(selector)
      .forEach(element => {

        element.textContent =
          value || '';

      });

  }



  function setAuthHref(
    selector,
    value
  ) {

    document
      .querySelectorAll(selector)
      .forEach(element => {

        element.href =
          value;

      });

  }




  function markAuthReady() {

    document.documentElement
      .classList.add(
        'pn-auth-ready'
      );

  }



  function showLoggedOutHeader() {

    document
      .querySelectorAll(
        '[data-pnauth-login-link]'
      )
      .forEach(element => {

        element.hidden =
          false;

        element.style.removeProperty(
          'display'
        );

      });


    document
      .querySelectorAll(
        '[data-pnauth-profile-wrap]'
      )
      .forEach(element => {

        element.hidden =
          true;

        element.style.setProperty(
          'display',
          'none',
          'important'
        );

      });

  }



  function showLoggedInHeader(
    profile
  ) {

    const role =
      profile?.role ||
      'student';


    const dashboardURL =
      dashboardForRole(
        role
      );


    document
      .querySelectorAll(
        '[data-pnauth-login-link]'
      )
      .forEach(element => {

        element.hidden =
          true;

        element.style.setProperty(
          'display',
          'none',
          'important'
        );

      });


    document
      .querySelectorAll(
        '[data-pnauth-profile-wrap]'
      )
      .forEach(element => {

        element.hidden =
          false;

        element.style.removeProperty(
          'display'
        );

      });


    setAuthText(
      '[data-pnauth-name]',
      profile?.full_name ||
      'PeerNest User'
    );


    setAuthText(
      '[data-pnauth-email]',
      profile?.email ||
      ''
    );


    setAuthText(
      '[data-pnauth-role]',
      role.charAt(0).toUpperCase()
      + role.slice(1)
    );


    setAuthAvatar(
      '[data-pnauth-avatar]',
      profile
    );


    setAuthHref(
      '[data-pnauth-dashboard-link]',
      dashboardURL
    );


    setAuthHref(
      '[data-pnauth-profile-link]',
      profileURLForRole(role)
    );


    updateHeaderActiveState(
      profile
    );

  }




  function updateHeaderActiveState(
    profile
  ) {

    const role =
      profile?.role ||
      'student';

    const path =
      window.location.pathname
        .replace(/\/+$/, '') ||
      '/';

    const dashboardURL =
      dashboardForRole(role);

    const profileURL =
      '/pages/profile';


    document
      .querySelectorAll(
        '[data-pnauth-dashboard-link]'
      )
      .forEach(link => {

        const active =
          path === dashboardURL;

        link.classList.toggle(
          'is-active',
          active
        );

        if (active) {
          link.setAttribute(
            'aria-current',
            'page'
          );
        } else {
          link.removeAttribute(
            'aria-current'
          );
        }

      });


    document
      .querySelectorAll(
        '[data-pnauth-profile-link]'
      )
      .forEach(link => {

        const active =
          path === profileURL;

        link.classList.toggle(
          'is-active',
          active
        );

        if (active) {
          link.setAttribute(
            'aria-current',
            'page'
          );
        } else {
          link.removeAttribute(
            'aria-current'
          );
        }

      });

  }



  function isTemporaryAuthFailure(error) {
    if (error?.pnAuthTransient) return true;
    const status = Number(error?.status || 0);
    if (status === 429 || status >= 500) return true;
    const message = String(error?.message || '');
    return /(networkerror|failed to fetch|load failed|fetch failed|timeout|timed out|offline|connection interrupted|failed \(?(?:429|5\d\d)\)?)/i
      .test(message);
  }

  function showReconnectionNotice(root) {
    const loading = root?.querySelector(
      '[data-pndash-loading], [data-pnprofile-loading]'
    );
    if (!loading) return;
    loading.hidden = false;
    let note = loading.querySelector('[data-pnauth-reconnection]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.pnauthReconnection = '1';
      loading.appendChild(note);
    }
    note.textContent =
      'Connection interrupted. Your sign-in is being kept. ' +
      'Reconnect to the internet or refresh this page.';
  }

  // Only share in-flight authentication work. Do not persist access tokens,
  // profiles or user-specific cached data into browser storage.
  let authContextInFlight = null;

  function getAuthContext() {
    if (authContextInFlight) return authContextInFlight;

    const request = (async () => {
      const session = await window.PeerNestDB.getSession();
      if (!session?.access_token) {
        return { session: null, user: null, profile: null };
      }
      const user = await window.PeerNestDB.getCurrentUser();
      if (!user) {
        return { session: null, user: null, profile: null };
      }
      // The user has already been validated above. Avoid a second
      // /auth/v1/user network request inside getMyProfile().
      const profile = await window.PeerNestDB.getMyProfile(user);
      return { session, user, profile };
    })();

    authContextInFlight = request;
    void request.then(
      () => { if (authContextInFlight === request) authContextInFlight = null; },
      () => { if (authContextInFlight === request) authContextInFlight = null; }
    );
    return request;
  }


  async function initGlobalHeader() {

    if (
      !document.querySelector(
        '[data-pnauth-login-link], [data-pnauth-profile-wrap]'
      )
    ) {

      markAuthReady();

      return;

    }


    try {

      const {
        profile
      } =
        await getAuthContext();


      if (
        !profile ||
        profile.account_status !==
          'active'
      ) {

        showLoggedOutHeader();

        markAuthReady();

        return;

      }


      showLoggedInHeader(
        profile
      );

      markAuthReady();

    }

    catch (error) {

      console.error(
        '[PeerNest Auth] Header state failed:',
        error
      );


      // A mobile connection failure is not proof of logout.
      if (!isTemporaryAuthFailure(error)) showLoggedOutHeader();
      markAuthReady();

    }

  }



  function bindGlobalLogout() {

    document
      .querySelectorAll(
        '[data-pnauth-logout]'
      )
      .forEach(button => {

        if (
          button.dataset
            .pnauthBound ===
            '1'
        ) {

          return;

        }


        button.dataset
          .pnauthBound =
          '1';


        button.addEventListener(
          'click',
          async event => {

            event.preventDefault();


            try {

              await window.PeerNestDB
                .signOut();

            }

            catch (error) {

              console.error(
                '[PeerNest Auth] Sign out failed:',
                error
              );

            }


            window.location.href =
              '/';

          }
        );

      });

  }



  function fillDashboardProfile(
    profile
  ) {

    setAuthText(
      '[data-pndash-name]',
      profile?.full_name ||
      'PeerNest User'
    );


    setAuthText(
      '[data-pndash-email]',
      profile?.email ||
      ''
    );


    setAuthText(
      '[data-pndash-role]',
      profile?.role
        ? (
            profile.role
              .charAt(0)
              .toUpperCase()
            +
            profile.role.slice(1)
          )
        : ''
    );


    setAuthText(
      '[data-pndash-status]',
      profile?.account_status ||
      ''
    );


    setAuthAvatar(
      '[data-pndash-avatar]',
      profile
    );

  }




  // PN_SHARED_PROFILE_AVATAR_V1
  function setAuthAvatar(selector, profile) {
    const url = typeof profile?.avatar_url === 'string'
      ? profile.avatar_url.trim()
      : '';

    const fallback = initialsForProfile(profile);

    document.querySelectorAll(selector).forEach(element => {
      element.textContent = url ? '' : fallback;

      element.style.setProperty(
        'background-image',
        url ? `url(${JSON.stringify(url)})` : 'none',
        'important'
      );

      element.style.setProperty(
        'background-size',
        url ? 'cover' : '',
        'important'
      );

      element.style.setProperty(
        'background-position',
        url ? 'center' : '',
        'important'
      );

      element.style.setProperty(
        'background-repeat',
        'no-repeat',
        'important'
      );
    });
  }


  function redirectToLogin() {

    const next =
      window.location.pathname
      + window.location.search
      + window.location.hash;


    window.location.replace(
      '/pages/login?next='
      + encodeURIComponent(next)
    );

  }



  async function initDashboardGuard() {

    const dashboard =
      document.querySelector(
        '[data-pnauth-dashboard]'
      );


    if (!dashboard) {
      return;
    }


    const expectedRole =
      dashboard.dataset.role;


    try {

      const {
        profile
      } =
        await getAuthContext();


      if (!profile) {

        redirectToLogin();

        return;

      }


      if (
        profile.account_status !==
        'active'
      ) {

        try {

          await window.PeerNestDB
            .signOut();

        }

        catch (_) {}


        window.location.replace(
          '/pages/login?account='
          + encodeURIComponent(
              profile.account_status
            )
        );

        return;

      }


      /*
       * UX route guard.
       *
       * Actual data security is enforced by
       * Supabase RLS, not by hiding pages.
       */

      if (
        expectedRole &&
        profile.role !==
          expectedRole
      ) {

        window.location.replace(
          dashboardForRole(
            profile.role
          )
        );

        return;

      }


      fillDashboardProfile(
        profile
      );


      const loading =
        dashboard.querySelector(
          '[data-pndash-loading]'
        );


      const content =
        dashboard.querySelector(
          '[data-pndash-content]'
        );


      if (loading) {
        loading.hidden = true;
      }


      if (content) {
        content.hidden = false;
      }


      document.dispatchEvent(
        new CustomEvent(
          'peernest:dashboard-ready',
          {
            detail:{
              profile
            }
          }
        )
      );

    }

    catch (error) {

      console.error(
        '[PeerNest Auth] Dashboard guard failed:',
        error
      );

      if (isTemporaryAuthFailure(error)) {
        showReconnectionNotice(dashboard);
        return;
      }
      redirectToLogin();

    }

  }




  function fillAccountProfile(
    profile
  ) {

    const role =
      profile?.role
        ? (
            profile.role
              .charAt(0)
              .toUpperCase()
            +
            profile.role.slice(1)
          )
        : '';

    setAuthText(
      '[data-pnprofile-name]',
      profile?.full_name ||
      'PeerNest User'
    );

    setAuthText(
      '[data-pnprofile-email]',
      profile?.email ||
      '—'
    );

    setAuthText(
      '[data-pnprofile-phone]',
      profile?.phone ||
      'Not added yet'
    );

    setAuthText(
      '[data-pnprofile-role]',
      role
    );

    setAuthText(
      '[data-pnprofile-status]',
      profile?.account_status ||
      ''
    );

    setAuthText(
      '[data-pnprofile-avatar]',
      initialsForProfile(profile)
    );


    let memberSince =
      '—';

    if (profile?.created_at) {

      const date =
        new Date(
          profile.created_at
        );

      if (
        !Number.isNaN(
          date.getTime()
        )
      ) {

        memberSince =
          new Intl.DateTimeFormat(
            'en-IN',
            {
              day:'numeric',
              month:'short',
              year:'numeric'
            }
          ).format(date);

      }

    }


    setAuthText(
      '[data-pnprofile-created]',
      memberSince
    );

  }



  async function initProfilePage() {

    const page =
      document.querySelector(
        '[data-pnauth-profile-page]'
      );

    if (!page) {
      return;
    }


    try {

      const {
        profile
      } =
        await getAuthContext();


      if (!profile) {

        redirectToLogin();

        return;

      }


      if (
        profile.account_status !==
        'active'
      ) {

        try {

          await window.PeerNestDB
            .signOut();

        }

        catch (_) {}


        window.location.replace(
          '/pages/login?account='
          +
          encodeURIComponent(
            profile.account_status
          )
        );

        return;

      }


      fillAccountProfile(
        profile
      );


      const loading =
        page.querySelector(
          '[data-pnprofile-loading]'
        );

      const content =
        page.querySelector(
          '[data-pnprofile-content]'
        );


      if (loading) {
        loading.hidden = true;
      }

      if (content) {
        content.hidden = false;
      }

    }

    catch (error) {

      console.error(
        '[PeerNest Auth] Profile page failed:',
        error
      );

      if (isTemporaryAuthFailure(error)) {
        showReconnectionNotice(page);
        return;
      }
      redirectToLogin();

    }

  }



  async function initGlobalAuth() {

    bindGlobalLogout();


    await Promise.all([
      initGlobalHeader(),
      initDashboardGuard(),
      initProfilePage()
    ]);


    bindGlobalLogout();

  }



  /* ========================================================
     PN_AUTH_LOGIN_EXTRAS
  ======================================================== */

  function refreshAuthIcons() {

    if (
      window.lucide &&
      typeof window.lucide.createIcons ===
        'function'
    ) {

      window.lucide.createIcons();

    }

  }



  function initPasswordToggles() {

    document
      .querySelectorAll(
        '[data-pnauth-toggle-password]'
      )
      .forEach(button => {

        if (
          button.dataset
            .pnauthBound ===
          '1'
        ) {
          return;
        }


        button.dataset
          .pnauthBound =
          '1';


        button.addEventListener(
          'click',
          () => {

            const wrapper =
              button.closest(
                '.pnauth-input'
              );


            const input =
              wrapper?.querySelector(
                'input'
              );


            if (!input) {
              return;
            }


            const showing =
              input.type ===
              'text';


            input.type =
              showing
                ? 'password'
                : 'text';


            button.innerHTML =
              showing
                ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="12" cy="12" r="2.6" fill="none" stroke="currentColor" stroke-width="1.8"></circle></svg>'
                : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 3l18 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path><path d="M10.6 6.2A9.8 9.8 0 0 1 12 6c6 0 9.5 6 9.5 6a14.2 14.2 0 0 1-2.3 3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.2 6.2C3.8 8 2.5 12 2.5 12s3.5 6 9.5 6c1 0 2-.2 2.8-.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>';


            button.setAttribute(
              'aria-label',
              showing
                ? 'Show password'
                : 'Hide password'
            );


            refreshAuthIcons();

          }
        );

      });

  }



  function initSocialLogin() {

    document
      .querySelectorAll(
        '[data-pnauth-oauth]'
      )
      .forEach(button => {

        if (
          button.dataset
            .pnauthBound ===
          '1'
        ) {
          return;
        }


        button.dataset
          .pnauthBound =
          '1';


        button.addEventListener(
          'click',
          async () => {

            const provider =
              button.dataset
                .pnauthOauth;


            try {

              window.PeerNestDB
                .signInWithOAuth(
                  provider,
                  window.location.origin +
                  '/pages/login'
                );

            }

            catch (error) {

              const message =
                document.querySelector(
                  '[data-pnauth-message]'
                );


              if (message) {

                message.hidden =
                  false;

                message.dataset.type =
                  'error';

                message.textContent =
                  error.message ||
                  'Social login could not be started.';

              }

            }

          }
        );

      });

  }



  async function handleOAuthReturn() {

    let session = null;


    try {

      session =
        window.PeerNestDB
          .consumeOAuthRedirect();

    }

    catch (error) {

      const message =
        document.querySelector(
          '[data-pnauth-message]'
        );


      if (message) {

        message.hidden =
          false;

        message.dataset.type =
          'error';

        message.textContent =
          error.message ||
          'Social sign in failed.';

      }


      return;

    }


    if (!session) {
      return;
    }


    /*
     * Give the auth.users → profiles trigger
     * a moment to create the matching profile.
     */

    let profile =
      null;


    for (
      let attempt = 0;
      attempt < 12;
      attempt += 1
    ) {

      profile =
        await window.PeerNestDB
          .getMyProfile();


      if (profile) {
        break;
      }


      await new Promise(
        resolve =>
          setTimeout(
            resolve,
            250
          )
      );

    }


    if (!profile) {
      return;
    }


    if (
      profile.account_status !==
      'active'
    ) {

      await window.PeerNestDB
        .signOut();


      return;

    }


    window.location.replace(
      '/'
    );

  }



  async function initLoginExtras() {

    initPasswordToggles();

    initSocialLogin();

    refreshAuthIcons();

    await handleOAuthReturn();

  }



  waitForDB(
    initLoginPage
  );


  waitForDB(
    initLoginExtras
  );


  waitForDB(
    initGlobalAuth
  );

  // Mobile browsers may suspend pages while connectivity changes.
  // Retry a failed auth check after returning online/foreground;
  // do not attempt token refresh through a periodic background timer.
  let authRecheckPending = false;
  function recheckAuthAfterResume() {
    if (authRecheckPending || !window.PeerNestDB) return;
    authRecheckPending = true;
    initGlobalAuth()
      .catch(error => console.warn('[PeerNest Auth] Retry pending:', error))
      .finally(() => { authRecheckPending = false; });
  }
  window.addEventListener('online', recheckAuthAfterResume);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) recheckAuthAfterResume();
  });

  window.PeerNestAuth = {
    dashboardForRole,
    getAuthContext,
    initGlobalHeader,
    initDashboardGuard
  };

})();
